import { computed, inject } from '@angular/core';
import { UserStore } from '../../store/user/user.store';
import { UserStatus } from '../../model/user-status-info.model';
import { toObservable } from '@angular/core/rxjs-interop';

export class RegistrationWizardStateService {
  userStore = inject(UserStore);

  isNoAccessExitButtonHidden$ = toObservable(
    computed(() => this.userStore.userStatusInfo.status() === null || this.userStore.userStatusInfo.status() !== UserStatus.UNKNOWN),
  );
  shouldSkipNoAccess = computed(() => this.userStore.userStatusInfo.status() !== UserStatus.UNKNOWN);

  shouldSkipTermsOfUse = computed(() => this.userStore.userStatusInfo.status() !== UserStatus.INVITED);
  canEnterTermsOfUse = computed(() => this.userStore.userStatusInfo?.status() === UserStatus.INVITED);

  canEnterVerification = computed(() => this.isStatusVerificationPendingOrError());
  shouldSkipVerification = this.userStore.isActive;

  canEnterDsgvo = this.userStore.isActive;

  isStatusVerificationPendingOrError(): boolean {
    return (
      this.userStore.userStatusInfo.status() === UserStatus.VERIFICATION_PENDING ||
      this.userStore.userStatusInfo.status() === UserStatus.REGISTRATION_ERROR
    );
  }
}
